import FilterDropdown from './filter-dropdown';
import './filter-dropdown.scss';

export default FilterDropdown;
